import { useAppRouter } from '@/common/route/useAppRouter';
import { encrypt } from '@/common/utils/cryptoUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useAppStore } from '@/modules/apps/store';
import { useAuthStore } from '@/modules/auth/store';
import { ROUTE_NAME_HOMEPAGE } from '@/modules/main/router';
import { useUiStore } from '@/modules/ui/store';
import authService from '@/services/auth';
import { useVuelidate } from '@vuelidate/core';
import { helpers, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useVerify() {
    const router = useAppRouter();
    const authStore = useAuthStore();
    const appStore = useAppStore();
    const uiStore = useUiStore();

    const model = reactive({
        mfaCode: ''
    });

    const validations = {
        mfaCode: {
            required: helpers.withMessage('MFA code is required', required),
            validFormat: helpers.withMessage('Must contain exactly 6 digits', helpers.regex(/^\d{6}$/))
        }
    };

    const v$ = useVuelidate(validations, model);

    const verify = useCrudActions().executeAction({
        validator: v$,
        request: () => authService.verifyMFACode(model.mfaCode),
        successMessage: 'Verify succeeded',
        onSuccess: async ({ data }) => {
            const encryptedTrustToken = await encrypt(data.trustToken);
            authStore.setTrustToken(encryptedTrustToken);
            await authStore.loadRoles();
            await appStore.loadApps();
            uiStore.resetLoading();
            router.push({ name: ROUTE_NAME_HOMEPAGE });
        }
    });

    return { model, v$, verify };
}
